import React from 'react';
import { Reveal } from './Reveal';
import { TestimonialCard } from './TestimonialCard';
import { earlyTestimonials } from '../constants/data';
export function EarlyTestimonials() {
  return <section className="w-full px-5 py-16 sm:py-20" style={{
    backgroundColor: '#111111'
  }} data-id="element-75">
      <div className="mx-auto max-w-6xl" data-id="element-76">
        <Reveal data-id="element-77">
          <h2 className="text-center text-2xl sm:text-3xl lg:text-4xl font-bold" data-id="element-78">
            Lo que dicen los que ya cambiaron su economía
          </h2>
        </Reveal>
        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-79">
          {earlyTestimonials.map((t, i) => <Reveal key={t.initials} delay={i * 0.1} data-id="element-80">
              <TestimonialCard t={t} data-id="element-81" />
            </Reveal>)}
        </div>
      </div>
    </section>;
}